
    import './styles.scoped.css';
    export default {
  "code-editor": "awsui_code-editor_1gl9c_1amn6_98",
  "code-editor-refresh": "awsui_code-editor-refresh_1gl9c_1amn6_534",
  "pane": "awsui_pane_1gl9c_1amn6_546",
  "pane__close-container": "awsui_pane__close-container_1gl9c_1amn6_557",
  "pane__list": "awsui_pane__list_1gl9c_1amn6_562",
  "pane__table": "awsui_pane__table_1gl9c_1amn6_569",
  "pane__item": "awsui_pane__item_1gl9c_1amn6_574",
  "pane__cell": "awsui_pane__cell_1gl9c_1amn6_574",
  "pane__item--highlighted": "awsui_pane__item--highlighted_1gl9c_1amn6_588",
  "pane__location": "awsui_pane__location_1gl9c_1amn6_609",
  "pane__description": "awsui_pane__description_1gl9c_1amn6_609",
  "focus-lock": "awsui_focus-lock_1gl9c_1amn6_624",
  "resizable-box": "awsui_resizable-box_1gl9c_1amn6_647",
  "resizable-box-handle": "awsui_resizable-box-handle_1gl9c_1amn6_652",
  "editor": "awsui_editor_1gl9c_1amn6_689",
  "status-bar": "awsui_status-bar_1gl9c_1amn6_722",
  "status-bar-with-hidden-pane": "awsui_status-bar-with-hidden-pane_1gl9c_1amn6_731",
  "status-bar__left": "awsui_status-bar__left_1gl9c_1amn6_735",
  "status-bar__left-virtual": "awsui_status-bar__left-virtual_1gl9c_1amn6_742",
  "status-bar__right": "awsui_status-bar__right_1gl9c_1amn6_746",
  "status-bar__language-mode": "awsui_status-bar__language-mode_1gl9c_1amn6_750",
  "status-bar__cursor-position": "awsui_status-bar__cursor-position_1gl9c_1amn6_750",
  "status-bar__cog-button": "awsui_status-bar__cog-button_1gl9c_1amn6_755",
  "status-bar-virtual": "awsui_status-bar-virtual_1gl9c_1amn6_759",
  "tab-button": "awsui_tab-button_1gl9c_1amn6_765",
  "tab-button--refresh": "awsui_tab-button--refresh_1gl9c_1amn6_778",
  "tab-button--active": "awsui_tab-button--active_1gl9c_1amn6_792",
  "tab-button--disabled": "awsui_tab-button--disabled_1gl9c_1amn6_812",
  "tab-button--divider": "awsui_tab-button--divider_1gl9c_1amn6_842",
  "tab-button--errors": "awsui_tab-button--errors_1gl9c_1amn6_849",
  "tab-button--warnings": "awsui_tab-button--warnings_1gl9c_1amn6_849",
  "loading-screen": "awsui_loading-screen_1gl9c_1amn6_853",
  "error-screen": "awsui_error-screen_1gl9c_1amn6_854"
};
  